import { CommonEnums } from '../common.enums';

export class Usr {
    usr_Id: number;
    login_Id: string;
    usrFullNm: string;
    usrEmail: string;
    usrPrimPhone: string;
    usrDesc: string;
    usrPasswd: string;
    updateBy: string;
    lastUpdateBy: string;
    updateDt: Date;
    adminFlag: string; 
    imageUrl: string;
    disableFlag: string;

    constructor() {
        this.setDefaults();
	}
	
	setDefaults() {
		this.usr_Id = CommonEnums.defaults.LONG_VAL;
		this.login_Id = CommonEnums.defaults.STRING_EMPTY;
		this.usrFullNm = CommonEnums.defaults.STRING_EMPTY;
		this.usrEmail = CommonEnums.defaults.STRING_EMPTY;
		this.usrPrimPhone = CommonEnums.defaults.STRING_EMPTY;
		this.usrDesc = CommonEnums.defaults.STRING_EMPTY;
		this.usrPasswd = CommonEnums.defaults.STRING_EMPTY;
		this.updateBy = CommonEnums.defaults.STRING_EMPTY;
		this.lastUpdateBy = CommonEnums.defaults.STRING_EMPTY;
		this.updateDt = new Date(); //TODO
		this.adminFlag=CommonEnums.defaults.STRING_VAL_NO;
		this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
		this.disableFlag = CommonEnums.defaults.STRING_VAL_NO;
	}

	static parse(usrTmp: Usr): Usr {
		let usr: Usr = new Usr();
		usr.copyFrom(usrTmp);
		return usr;
	}
	
	getPrimaryKey(): string {
        return this.usr_Id.toString(); 
    }

    copy(): Usr {
        let usrTemp: Usr = new Usr();

        usrTemp.usr_Id = this.usr_Id;
		usrTemp.login_Id = this.login_Id;
		usrTemp.usrFullNm = this.usrFullNm;
		usrTemp.usrEmail = this.usrEmail;
		usrTemp.usrPrimPhone = this.usrPrimPhone;
		usrTemp.usrDesc = this.usrDesc;
		usrTemp.usrPasswd = this.usrPasswd;
		usrTemp.updateBy = this.updateBy;
		usrTemp.lastUpdateBy = this.lastUpdateBy;
		usrTemp.updateDt = this.updateDt;
		usrTemp.adminFlag=this.adminFlag;
		usrTemp.imageUrl = this.imageUrl;
		usrTemp.disableFlag = this.disableFlag;

        return usrTemp;
    }

    copyFrom( usrTemp: Usr ): void {
        this.usr_Id = usrTemp.usr_Id;
		this.login_Id = usrTemp.login_Id;
		this.usrFullNm = usrTemp.usrFullNm;
		this.usrEmail = usrTemp.usrEmail;
		this.usrPrimPhone = usrTemp.usrPrimPhone;
		this.usrDesc = usrTemp.usrDesc;
		this.usrPasswd = usrTemp.usrPasswd;
		this.updateBy = usrTemp.updateBy;
		this.lastUpdateBy = usrTemp.lastUpdateBy;
		this.updateDt = usrTemp.updateDt;
		this.adminFlag=usrTemp.adminFlag;
		this.imageUrl = usrTemp.imageUrl;
		this.disableFlag = usrTemp.disableFlag;
	}
	
	compare( usrTemp: Usr ): string {
		let usrString: string = this.toString(false);
		let usrTempString: string = usrTemp.toString(false);

		if( usrString != usrTempString ) {
			return usrString + ', ' + usrTempString;
		}

		return '';
	}

	toString(isNotCompare: boolean = true): string {
		let str: string = "Usr [usr_Id=" + this.usr_Id + ", login_Id=" + this.login_Id + 
			", usrFullNm=" + this.usrFullNm + ", usrEmail=" + this.usrEmail + 
			", usrPrimPhone=" + this.usrPrimPhone + ", usrDesc=" + this.usrDesc + 
			", usrPasswd=" + "****" + ", updateBy=" + this.updateBy + ", lastUpdateBy=" + this.lastUpdateBy + 
			", updateDt=" + this.updateDt + ", adminFlag=" + this.adminFlag + ", imageUrl=" + this.imageUrl + 
			", disableFlag=" + this.disableFlag;
			
			if(isNotCompare) {
                str += ''
            }
            
            str += ']';

            return str;
    }
}	
